/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import Component from 'can/component/component';
import template from './live-video-modal.stache';
import device from 'scripts/utils/device';
const liveVideoModalSettings = window.globalSettings.liveVideoModal;

export const showLiveVideoModal = () => {
    can.$(can.stache('<live-video-modal></live-video-modal>')({})).appendTo(
        document.body,
    );
};

Component.extend({
    tag: 'live-video-modal',
    template: template,
    viewModel: {
        liveVideoModalElement: null,
        downloadAppLink: '',
        year: liveVideoModalSettings.year,
        image: liveVideoModalSettings.image,
        closeLiveVideoModal() {
            can.remove(this.attr('liveVideoModalElement'));
        },
    },
    init() {
        if (device.isIos()) {
            this.viewModel.attr(
                'downloadAppLink',
                'https://itunes.apple.com/us/app/u-s-open-golf-championship/id319204550?mt=8',
            );
        } else if (device.isAndroid) {
            this.viewModel.attr(
                'downloadAppLink',
                'https://play.google.com/store/apps/details?id=com.ibm.events.android.usga&hl=en_US',
            );
        } else {
            this.viewModel.attr(
                'downloadAppLink',
                'http://www.usga.org/content/usga/home-page/apps.html',
            );
        }
    },
    events: {
        inserted: function($el) {
            this.viewModel.attr('liveVideoModalElement', $el);
        },
    },
});
